import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Permission_conditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.permission_conditions_Id,
          sortable: true,
          cell: (row) => <span>{row.permission_conditions_Id}</span>,
        },
        { name: "Condition Name", selector: (row, i) => row.condition_name, sortable: true, cell: (row) => <span>{row.condition_name}</span>, }, { name: "Condition Description", selector: (row, i) => row.condition_description, sortable: true, cell: (row) => <span>{row.condition_description}</span>, }, { name: "Condition Logic", selector: (row, i) => row.condition_logic, sortable: true, cell: (row) => <span>{row.condition_logic}</span>, }, { name: "Applicable Scopes", selector: (row, i) => row.applicable_scopes, sortable: true, cell: (row) => <span>{row.applicable_scopes}</span>, }, { name: "Is System Condition", selector: (row, i) => row.is_system_condition, sortable: true, cell: (row) => <span>{row.is_system_condition}</span>, }, { name: "Created By", selector: (row, i) => row.created_by, sortable: true, cell: (row) => <span>{row.created_by}</span>, }, { name: "Status", selector: (row, i) => row.status, sortable: true, cell: (row) => <span>{row.status}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Permission_conditionseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      permission_conditions_Id: "",
      condition_name: '', condition_description: '', condition_logic: '', applicable_scopes: '', is_system_condition: '', created_by: '', statustypemaster: [], status: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'condition_name', inputType: 'Text', displayName: 'Condition Name', validationOptions: { isRequired: false } },
      { fieldName: 'condition_description', inputType: 'Text', displayName: 'Condition Description', validationOptions: { isRequired: false } },
      { fieldName: 'condition_logic', inputType: 'Text', displayName: 'Condition Logic', validationOptions: { isRequired: false } },
      { fieldName: 'applicable_scopes', inputType: 'Text', displayName: 'Applicable Scopes', validationOptions: { isRequired: false } },
      { fieldName: 'is_system_condition', inputType: 'Number', displayName: 'Is System Condition', validationOptions: { isRequired: false } },
      { fieldName: 'created_by', inputType: 'Number', displayName: 'Created By', validationOptions: { isRequired: false } },
      { fieldName: 'status', inputType: 'Select', displayName: 'Status', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      condition_name: '', condition_description: '', condition_logic: '', applicable_scopes: '', is_system_condition: '', created_by: '', statustypemaster: [], status: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      condition_name: '', condition_description: '', condition_logic: '', applicable_scopes: '', is_system_condition: '', created_by: '', statustypemaster: [], status: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Permission_conditionseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      permission_conditions_Id: row.permission_conditions_Id,
      condition_name: row.condition_name, condition_description: row.condition_description, condition_logic: row.condition_logic, applicable_scopes: row.applicable_scopes, is_system_condition: row.is_system_condition, created_by: row.created_by, statustypemaster: [], status: row.status,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Permission_conditionsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Permission_conditions/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Permission_conditionssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('condition_name', this.state.condition_name);
    formData.append('condition_description', this.state.condition_description);
    formData.append('condition_logic', this.state.condition_logic);
    formData.append('applicable_scopes', this.state.applicable_scopes);
    formData.append('is_system_condition', this.state.is_system_condition);
    formData.append('created_by', this.state.created_by);
    formData.append('status', this.state.status);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Permission_conditions/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Permission_conditionsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ condition_name: '', condition_description: '', condition_logic: '', applicable_scopes: '', is_system_condition: '', created_by: '', statustypemaster: [], status: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Permission_conditionsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("permission_conditions_Id", this.state.permission_conditions_Id);
    formData.append('condition_name', this.state.condition_name);
    formData.append('condition_description', this.state.condition_description);
    formData.append('condition_logic', this.state.condition_logic);
    formData.append('applicable_scopes', this.state.applicable_scopes);
    formData.append('is_system_condition', this.state.is_system_condition);
    formData.append('created_by', this.state.created_by);
    formData.append('status', this.state.status);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Permission_conditions/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Permission_conditionsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Permission_conditionsfetchHandler();
    this.statustypemasterfetchHandler();

    //***componentDidMount
  }

  handlecondition_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ condition_name: fieldValue });
  }; handlecondition_descriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ condition_description: fieldValue });
  }; handlecondition_logicChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ condition_logic: fieldValue });
  }; handleapplicable_scopesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ applicable_scopes: fieldValue });
  }; handleis_system_conditionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ is_system_condition: fieldValue });
  }; handlecreated_byChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ created_by: fieldValue });
  }; handlestatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  }; statustypemasterfetchHandler = () => {
    fetch(configData.api_url + "C_Statustypemaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ statustypemaster: data.list });
        }
      });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this permission_conditions?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('permission_conditions_Id', row.permission_conditions_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Permission_conditions/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Permission_conditionsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Permission Conditions</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Permission_conditions</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Condition Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecondition_nameChange} className="form-control" name="condition_name" value={this.state.condition_name} required="required" placeholder="Enter Condition Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.condition_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Condition Description</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecondition_descriptionChange} className="form-control" name="condition_description" value={this.state.condition_description} required="required" placeholder="Enter Condition Description" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.condition_description} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Condition Logic</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecondition_logicChange} className="form-control" name="condition_logic" value={this.state.condition_logic} required="required" placeholder="Enter Condition Logic" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.condition_logic} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Applicable Scopes</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleapplicable_scopesChange} className="form-control" name="applicable_scopes" value={this.state.applicable_scopes} required="required" placeholder="Enter Applicable Scopes" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.applicable_scopes} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Is System Condition</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleis_system_conditionChange} className="form-control" name="is_system_condition" value={this.state.is_system_condition} required="required" placeholder="Enter Is System Condition" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_system_condition} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Created By</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecreated_byChange} className="form-control" name="created_by" value={this.state.created_by} required="required" placeholder="Enter Created By" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.created_by} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                        <option defaultValue> Select Status </option>
                                        {this.state.statustypemaster.map((api, index, idx) => (
                                          <option key={index} value={api.active}> {api.active} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Permission_conditionssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Permission_conditions</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Condition Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecondition_nameChange} className="form-control" name="condition_name" value={this.state.condition_name} required="required" placeholder="Enter Condition Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.condition_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Condition Description</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecondition_descriptionChange} className="form-control" name="condition_description" value={this.state.condition_description} required="required" placeholder="Enter Condition Description" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.condition_description} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Condition Logic</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecondition_logicChange} className="form-control" name="condition_logic" value={this.state.condition_logic} required="required" placeholder="Enter Condition Logic" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.condition_logic} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Applicable Scopes</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleapplicable_scopesChange} className="form-control" name="applicable_scopes" value={this.state.applicable_scopes} required="required" placeholder="Enter Applicable Scopes" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.applicable_scopes} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Is System Condition</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleis_system_conditionChange} className="form-control" name="is_system_condition" value={this.state.is_system_condition} required="required" placeholder="Enter Is System Condition" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.is_system_condition} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Created By</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecreated_byChange} className="form-control" name="created_by" value={this.state.created_by} required="required" placeholder="Enter Created By" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.created_by} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                          <option defaultValue> Select Status </option>
                                          {this.state.statustypemaster.map((api, index, idx) => (
                                            <option key={index} value={api.active}> {api.active} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Permission_conditionsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}